<div class="loading-container">
  <div class="spinner"></div>
  <div class="loading-text">Loading...</div>
</div>
